module.exports = __webpack_public_path__ + "img/15.f53aa9ee.jpg";